'use strict';

var processInclude = require('base/util');

$(function () {
    processInclude(require('friartux/lookBuilder/lookBuilder'));
    processInclude(require('friartux/lookBuilder/fto'));
    processInclude(require('friartux/product/quickView'));
    processInclude(require('friartux/components/inputDate'));
    processInclude(require('friartux/components/datepicker'));
    processInclude(require('friartux/components/pdfModalViewer'));
});
